export const buildNumber = '20260226.2';
export const version = 'main';
export const latestCommit = '8843e65d5e49330f6b60a2d95649cce2d475f882';
